import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Career } from '../interfaces/career';

@Injectable({
  providedIn: 'root'
})
export class CareerService {
  private myAppUrl: string;
  private myApiUrl: string;

  constructor(private http: HttpClient) {
    this.myAppUrl = environment.endpoint;
    this.myApiUrl = 'api/careers/'
  }
  getListCareers(): Observable<Career[]> {

      return this.http.get<Career[]>(`${this.myAppUrl}${this.myApiUrl}`);
     }
   
     deleteCareer(id: number): Observable<void> {
       return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     saveCareer(career: Career): Observable<void> {
       return this.http.post<void>(`${this.myAppUrl}${this.myApiUrl}`,career)
     }
   
     getCareer(id: number): Observable<Career> {
       return this.http.get<Career>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     updateCareer(id: number, career: Career): Observable<void> {
       return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}`, career);
     }
   }